<script>
  import { format } from "date-fns";

  const long = new Intl.DateTimeFormat("en-US", {
    year:"numeric",
    month:"short",
    weekday:"short",
    day:"numeric",
    hour:"numeric",
    minute:"numeric",
    timeZoneName:"short",
  }).format;

  function generated(date) {
    return long(date);
  }

  // expected utc time
  export let loadTime = new Date();
</script>

<footer>
  {#await loadTime then time}
    <time datetime={time}>{generated(new Date(time))}</time>
  {/await}
</footer>
